import template from './error.html';
import controller from './error.controller';
import './error.scss';

let errorComponent = {
  restrict: 'E',
  bindings: {
    error: '<'
  },
  template,
  controller,
};

export default errorComponent;



// WEBPACK FOOTER //
// ./client/app/components/error/error.component.js